import { parseDefaultOptions } from '@/utils';
import type {
  LogicBlockIndex,
  LogicBlockRecord,
  BlockRule,
} from '@morph-mapper/node-logic';
import type { NodeId, NodeInstance } from '../types';
import type { MakeOptional } from '@/types';

type CreateNodeInstanceArgs = {
  kind: LogicBlockIndex;
  id?: NodeId;
};

export const createNodeInstance = (
  { kind, id }: CreateNodeInstanceArgs,
  logicBlocks: LogicBlockRecord<any, Set<BlockRule>>
): MakeOptional<NodeInstance<typeof kind>, 'id'> => {
  const block = logicBlocks[kind];

  return {
    id,
    kind,
    options: parseDefaultOptions(block.options),
  };
};
